import { render, staticRenderFns } from "./WsaFormTextField.vue?vue&type=template&id=5e08f08a"
import script from "./WsaFormTextField.vue?vue&type=script&lang=ts"
export * from "./WsaFormTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports